import R from 'ramda';
import moment from 'moment';
import { MECHANISMS } from '../../../server/constants';

export const formatActivatedByUserText = propName => R.compose(
  v => v.full_name || v.displayname || v.email || v._id || 'unknown',
  R.defaultTo({}),
  R.prop(propName)
);

export const ProductActivatedInfoText = R.cond([
  [R.pathEq(['activated_info', 'mechanism'], MECHANISMS.COVID), R.always('covid demo period')],
  [R.pathEq(['activated_info', 'mechanism'], MECHANISMS.FIRSTLOGIN), R.always('free trial')],
  [R.pathEq(['activated_info', 'mechanism'], MECHANISMS.FASTSPRING), R.always('fastspring purchase')],
  [R.pathEq(['activated_info', 'mechanism'], MECHANISMS.SERIAL_UPGRADE), R.always('Max 6 free upgrade')],
  [R.pathEq(['activated_info', 'mechanism'], MECHANISMS.INSTITUTION_AC), R.always('Institution activation code')],
  [R.pathEq(['activated_info', 'mechanism'], MECHANISMS.RESELLER_AC), R.always('reseller purchase (AC)')],
  [R.pathEq(['activated_info', 'mechanism'], MECHANISMS.USER), R.ifElse(
    R.pathSatisfies(x => x, ['activated_by', '_id']),
    formatActivatedByUserText('activated_by'),
    R.always(null))],
  [R.T, R.always(null)]
]);

const returnText = l => 'fastspring (' +
  (
    R.path(['deactivated_info', 'return', 'date'], l)
      ? 'returned on ' + moment(R.path(['deactivated_info', 'return', 'date'], l)).format('YYYY-MM-DD') + ', '
      : ''
  ) +
  (
    R.path(['deactivated_info', 'return', 'reason'], l)
      ? R.path(['deactivated_info', 'return', 'reason'], l)
      : ''
  ) + ')';

export const ProductDeactivatedInfoText = R.cond([
  [R.path(['deactivated_info', 'return', 'type']), returnText],
  [R.T, R.always('fastspring')]
]);

export const ProductDeactivatedByText = R.cond([
  [R.path(['deactivated_by', '_id']), formatActivatedByUserText('deactivated_by')],
  [R.pathEq(['deactivated_info', 'mechanism'], MECHANISMS.FASTSPRING), ProductDeactivatedInfoText],
  [R.T, R.always(null)]
]);



// WEBPACK FOOTER //
// ./webAdmin/views/license/util.js